// extracted by mini-css-extract-plugin
module.exports = {"item":"Accordian_item__sBBJM","plusMinusIcon":"Accordian_plusMinusIcon__O9WeB","paragraph":"Accordian_paragraph__IfmJy","isOpen":"Accordian_isOpen__kCDon"};